import script from "./introducePage.vue?vue&type=script&setup=true&lang=js"
export * from "./introducePage.vue?vue&type=script&setup=true&lang=js"

import "./introducePage.vue?vue&type=style&index=0&id=59ec47b2&lang=css"

const __exports__ = script;

export default __exports__